import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=48237354&scoped=true&"
import script from "./Search.ts?vue&type=script&lang=ts&"
export * from "./Search.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48237354",
  null
  
)

export default component.exports
import {QSelect,QInput,QItem,QItemSection,QPopupProxy,QDate,QIcon,QBtn,QDialog,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign({QSelect,QInput,QItem,QItemSection,QPopupProxy,QDate,QIcon,QBtn,QDialog,QCard,QCardSection}, component.options.components || {})
